<template>
  <div class="compare-table-container">
    <!-- 页面标题 -->
    <div class="header-content" style="align-items: center;">
      <div style="font-size: 24px; color: white;">玩法数据对比</div>
      <div style="font-size: 20px; font-weight: bold; margin-top: 1%;">{{ displayTime }}</div>
    </div>

    <!-- 查询条件 -->
    <div style="text-align: center; margin-bottom: 10px; margin-top: 6%; padding-left: 16px; padding-right: 16px; border-radius: 8px;">
      <div class="datetime-container background-box" style="display: inline-flex; gap: 40px; justify-content: center;">
        <!-- 起止日期选择 -->
        <div class="datetime-group" style="display: inline-flex; align-items: center;">
          <label for="startDate" style="margin-right: 2%; margin-top: 2%; margin-left: 2%">开始时间:</label>
          <span style="display:block;width:40%;">
            <datetime
                input-style="width:100%;font-size:16px;"
                v-model="startDate"
                type="date"
                :format="{
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit'
                            }"
                :max-datetime="new Date().toISOString()"
                class="dt-input"
            />
          </span>
        </div>
        <div class="datetime-group" v-if="queryType === 'day'" style="display: inline-flex; align-items: center;">
          <label for="endDate" style="margin-right: 2%; margin-top: 2%; margin-left: 2%">结束时间:</label>
          <span style="display:block;width:40%;">
            <datetime
                input-style="width:100%;font-size:16px;"
                v-model="endDate"
                type="date"
                :format="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            }"
                :max-datetime="new Date().toISOString()"
                class="dt-input"
            />
          </span>
        </div>
      </div>
    </div>

    <!-- 玩法1和玩法2输入框 -->
    <div style="margin-bottom: 10px; text-align: center; padding-left: 16px; padding-right: 16px; border-radius: 8px;">
      <div class="form-row background-box" style="display: inline-flex; align-items: center; gap: 20px;">
        <!-- 玩法1 自动补全 -->
        <div class="custom-autocomplete" style="width:40%;position:relative;">
          <input
              v-model="gameName1"
              type="text"
              placeholder="请输入玩法1名称"
              @focus="showDropdown1"
              @input="onSearchInput1"
              @blur="hideSuggestions1"
              class="autocomplete-input"
          />
          <ul v-if="showSuggestions1" class="autocomplete-dropdown">
            <li
                v-for="item in filteredSuggestions1"
                :key="item.value"
                @click="onGameSelect1(item)"
            >
              {{ item.label }}
            </li>
          </ul>
        </div>
        <!-- 玩法2 自动补全 -->
        <div class="custom-autocomplete" style="width:40%;position:relative;">
          <input
              v-model="gameName2"
              type="text"
              placeholder="请输入玩法2名称"
              @focus="showDropdown2"
              @input="onSearchInput2"
              @blur="hideSuggestions2"
              class="autocomplete-input"
          />
          <ul v-if="showSuggestions2" class="autocomplete-dropdown">
            <li
                v-for="item in filteredSuggestions2"
                :key="item.value"
                @click="onGameSelect2(item)"
            >
              {{ item.label }}
            </li>
          </ul>
        </div>
      </div>
      <img src="@/assets/VS.png" class="vs-img" alt="vesus" />
    </div>

    <!-- 查询类型和查询按钮 -->
    <div style="margin-bottom: 10px;margin-top: -50px;text-align: center; padding-left: 16px; padding-right: 16px; border-radius: 8px;">
      <div class="form-row background-box" style="display: inline-flex; align-items: center; gap: 20px;">
        <el-radio-group v-model="queryType" style="display: inline-flex; gap: 2%; width: 50%; margin-left: 2%; margin-top: 1%;" @change="onQueryTypeChange">
          <el-radio :value="'hour'">按小时查询</el-radio>
          <el-radio :value="'day'">按天查询</el-radio>
        </el-radio-group>

        <el-button type="primary" @click="onCompare" style="width: 120px; margin-left: 20px;">
          一键对比
        </el-button>
      </div>
    </div>

    <!-- 玩法数据概况 -->
    <div style="text-align: center;">
      <h2>玩法数据概况</h2>
      <div style="display: inline-block;">
        <el-table :data="tableData" style="width: 100%" :border="true" :header-row-style="headerRowStyle" :header-cell-style="headerCellStyle">
          <!-- 一级表头: 日期 -->
          <el-table-column label="日期" align="center"  min-width="150">
            <template #header>
              <span>日期</span>
            </template>
            <template #default="{ row }">
              {{ row.rowName }}
            </template>
          </el-table-column>

          <template v-for="(date, index) in dateColumns" :key="`date-${index}`">
            <!-- 玩法名 -->
            <el-table-column :label="date" :colspan="2" align="center"  min-width="150">
              <template #header>
                <span>{{ date }}</span>
              </template>
              <!-- 动态生成二级表头，遍历每个日期 -->
              <template v-for="(gameName, index) in gameNames" :key="`game-${index}`">
                <!-- 玩法名 -->
                <el-table-column :label="gameName" :colspan="2" align="center"  min-width="150">
                  <template #header>
                    <span>{{ gameName }}</span>
                  </template>
                  <template #default="{ row }">
                    {{ row[`${date}_${gameName}`] }}
                  </template>
                </el-table-column>
              </template>
            </el-table-column>
          </template>


        </el-table>
      </div>
    </div>

    <!-- 折线图：活跃分布 -->
    <div style="text-align: center;">
      <h2>活跃分布</h2>
      <div style="display: inline-block;">
        <v-chart :option="activeDistributionChartOptions" style="width: 600px; height: 500px; margin-bottom: 20px; background-color: rgba(255, 255, 255, 0.95);" />
      </div>
    </div>

    <!-- 折线图：上榜主播人数 -->
    <div style="text-align: center;">
      <h2>上榜主播人数</h2>
      <div style="display: inline-block;">
        <v-chart :option="anchorCountChartOptions" style="width: 600px; height: 500px; margin-bottom: 20px; background-color: rgba(255, 255, 255, 0.95);" />
      </div>
    </div>

    <!-- 折线图：排名对比 -->
    <div style="text-align: center;">
      <h2>排名对比</h2>
      <div style="display: inline-block;">
        <v-chart :option="rankComparisonChartOptions" style="width: 600px; height: 500px; margin-bottom: 20px; background-color: rgba(255, 255, 255, 0.95);" />
      </div>
    </div>

    <!-- 折线图：首播主播数对比 -->
    <div style="text-align: center;">
      <h2>首播主播数对比</h2>
      <div style="display: inline-block;">
        <v-chart :option="newAnchorComparisonChartOptions" style="width: 600px; height: 500px; margin-bottom: 20px; background-color: rgba(255, 255, 255, 0.95);" />
      </div>
    </div>

    <!-- 折线图：总榜占比 -->
    <div style="text-align: center;">
      <h2>总榜占比</h2>
      <div style="display: inline-block;">
        <v-chart :option="totalRankProportionChartOptions" style="width: 600px; height: 500px; margin-bottom: 20px; background-color: rgba(255, 255, 255, 0.95);" />
      </div>
    </div>

    <!-- 折线图：本类型玩法活跃占比 -->
    <div style="text-align: center;">
      <h2>本类型玩法活跃占比</h2>
      <div style="display: inline-block;">
        <v-chart :option="categoryProportionChartOptions" style="width: 600px; height: 500px; margin-bottom: 20px; background-color: rgba(255, 255, 255, 0.95);" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import axios from 'axios'
import { ElTable, ElTableColumn, ElButton, ElRadioGroup, ElRadio } from 'element-plus'
import VChart from 'vue-echarts'
import { Datetime } from 'vue-datetime3'

const queryType = ref('hour')
const startDate = ref(new Date().toISOString().split('T')[0])  // 默认今天
const endDate = ref(new Date().toISOString().split('T')[0])    // 默认今天
const gameName1 = ref('')
const gameName2 = ref('')
const tableData = ref([])
const gameNames = ref([])  // 存储动态生成的游戏名列表
const dateColumns = ref([])

// 图表数据
const activeDistributionChartOptions = ref({})
const anchorCountChartOptions = ref({})
const rankComparisonChartOptions = ref({})
const newAnchorComparisonChartOptions = ref({})
const totalRankProportionChartOptions = ref({})
const categoryProportionChartOptions = ref({})

// displayTime计算
// 显示在顶部的大标题
const displayTime = computed(() => {
  if (!startDate.value) return ''
  if (queryType.value === 'day') {
    return endDate.value ? `${formatDate(startDate.value)} ~ ${formatDate(endDate.value)}` : `${formatDate(startDate.value)} ~ `
  } else {
    return formatDate(startDate.value)
  }
})

// 更新displayTime
const updateDisplayTime = () => {
  if (startDate.value === endDate.value) {
    displayTime.value = startDate.value  // 同一天
  } else {
    displayTime.value = `${startDate.value} - ${endDate.value}`  // 不同天
  }
}

// 一键对比查询接口
const onCompare = async () => {
  // 更新 displayTime
  updateDisplayTime()

  const params = {
    start_time: startDate.value,
    end_time: queryType.value === 'hour' ? startDate.value : endDate.value,
    query_type: queryType.value,
    game_name1: gameName1.value,
    game_name2: gameName2.value
  }

  try {
    const response = await axios.get('https://www.hudongwanfa.cn/api/data_comparison', { params })
    const data = response.data

    if (data.game_data_overview) {
      gameNames.value = Object.keys(data.game_data_overview) // 获取游戏名列表
      dateColumns.value = Object.keys(data.game_data_overview[gameNames.value[0]])
      console.log('dateColumns.value=' + dateColumns.value)
      console.log('gameNames.value=' + gameNames.value)

      tableData.value = transformGameDataOverview(data.game_data_overview)
    }

    updateCharts(data)
  } catch (error) {
    console.error(error)
    alert('查询失败，请重试')
  }
}

// 自动请求接口
onMounted(() => {
  onCompare()
})

// 转换游戏数据概况
const transformGameDataOverview = (data) => {
  const rows = []
  const rowNames = [
    { name: "玩法榜活跃度", key: "game_active_value" },
    { name: "玩法榜排名", key: "game_rank_position" },
    { name: "主播榜活跃度", key: "anchor_active_value" },
    { name: "主播榜排名", key: "anchor_rank_position" },
    { name: "上榜主播人数", key: "anchor_count" },
    { name: "人均上榜活跃", key: "anchor_avg_active" },
    { name: "上榜总场次", key: "anchor_session_count" },
    { name: "场均上榜活跃", key: "session_avg_active" },
    { name: "新主播人数", key: "new_anchor_count" },
    { name: "新主播上榜比例", key: "new_anchor_ratio" }
  ]

  rowNames.forEach((rowItem) => {
    const row = { rowName: rowItem.name }
    dateColumns.value.forEach((date) => {  // 遍历日期
      gameNames.value.forEach((gameName) => {  // 遍历游戏名
        const gameData = data[gameName]  // 获取对应游戏的数据
        const game = gameData[date]  // 获取对应日期的数据

        if (game) {  // 如果游戏数据存在
          let value = game[rowItem.key]  // 获取相应的值

          // 格式化数据
          if (rowItem.key === "game_active_value" || rowItem.key === "anchor_active_value" || rowItem.key === "session_avg_active" || rowItem.key === "anchor_avg_active") {
            value = formatScore(value);
          } else if (rowItem.key === "new_anchor_ratio") {
            value = formatPercentage(value);
          }

          // 存储格式化后的数据
          row[`${date}_${gameName}`] = value
        }
      })

    })
    rows.push(row)
  })

  // console.log('rows is:', rows)
  return rows
}

// 格式化为 X.x 万
const formatScore = (score) => {
  return (score / 10000).toFixed(1) + '万'
}

// 格式化为百分比
const formatPercentage = (value) => {
  return (value / 10).toFixed(1) + '%'
}

// 更新图表数据
const updateCharts = (data) => {
  updateActiveDistributionChart(data.active_distribution)
  updateAnchorCountChart(data.anchor_count)
  updateRankComparisonChart(data.rank_comparison)
  updateNewAnchorComparisonChart(data.new_anchor_comparison)
  updateTotalRankProportionChart(data.total_rank_proportion)
  updateCategoryProportionChart(data.category_proportion)
}

// 更新活跃分布图
const updateActiveDistributionChart = (data) => {
  const seriesData = Object.keys(data).map(gameName => ({
    name: gameName,
    type: 'line',
    data: data[gameName].map(item => item.total_score / 10000),
  }))

  activeDistributionChartOptions.value = {
    title: {
      text: '活跃分布',
      subtext: '单位(万)',
      left: 'center'
    },
    xAxis: {
      type: 'category',
      data: data[Object.keys(data)[0]].map(item => item.hour),
      axisLabel: {
        align: 'left',
      }
    },
    yAxis: {
      type: 'value',
    },
    legend: {
      data: Object.keys(data),
      left: 'center',
      top: 50
    },
    series: seriesData
  }
}

// 更新上榜主播人数图
const updateAnchorCountChart = (data) => {
  const seriesData = Object.keys(data).map(gameName => ({
    name: gameName,
    type: 'line',
    data: data[gameName].map(item => item.anchor_count),
  }))

  anchorCountChartOptions.value = {
    title: {
      text: '上榜主播人数',
      left: 'center'
    },
    xAxis: {
      type: 'category',
      data: data[Object.keys(data)[0]].map(item => item.hour),
    },
    yAxis: {
      type: 'value',
    },
    legend: {
      data: Object.keys(data),
      left: 'center',
      top: 30
    },
    series: seriesData
  }
}

// 更新排名对比图
const updateRankComparisonChart = (data) => {
  const seriesData = Object.keys(data).map(gameName => ({
    name: gameName,
    type: 'line',
    data: data[gameName].map(item => item.rank),
  }))

  rankComparisonChartOptions.value = {
    title: {
      text: '排名对比',
      left: 'center'
    },
    xAxis: {
      type: 'category',
      data: data[Object.keys(data)[0]].map(item => item.hour),
      name: '小时',               // 设置 x 轴名称为“小时”
      nameLocation: 'middle',     // 位置可以根据需要调整（可选）
      nameGap: 30                // 轴名称与轴之间的间距（可选）
    },
    yAxis: {
      type: 'value',
      inverse: true,
      name: '排名',               // 设置 y 轴名称为“排名”
      nameLocation: 'middle',     // 设置名称居中显示（可选）
      nameRotate: 90,             // y 轴名称旋转90度（可选）
      nameGap: 40                 // 轴名称与轴之间的间距（可选）
    },
    legend: {
      data: Object.keys(data),
      left: 'center',
      top: 30
    },
    series: seriesData
  }
}

// 更新首播主播数对比图
const updateNewAnchorComparisonChart = (data) => {
  const seriesData = Object.keys(data).map(gameName => ({
    name: gameName,
    type: 'line',
    data: data[gameName].map(item => item.new_anchor_count),
  }))

  newAnchorComparisonChartOptions.value = {
    title: {
      text: '首播主播数对比',
      left: 'center'
    },
    xAxis: {
      type: 'category',
      data: data[Object.keys(data)[0]].map(item => item.hour),
    },
    yAxis: {
      type: 'value'
    },
    legend: {
      data: Object.keys(data),
      left: 'center',
      top: 30
    },
    series: seriesData
  }
}

// 更新总榜占比图
const updateTotalRankProportionChart = (data) => {
  const seriesData = Object.keys(data).map(gameName => ({
    name: gameName,
    type: 'line',
    data: data[gameName].map(item => item.total_rank_proportion),
  }))

  totalRankProportionChartOptions.value = {
    title: {
      text: '总榜占比',
      left: 'center'
    },
    xAxis: {
      type: 'category',
      data: data[Object.keys(data)[0]].map(item => item.hour),
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value}%'  // 格式化为百分比
      }
    },
    legend: {
      data: Object.keys(data),
      left: 'center',
      top: 30
    },
    series: seriesData
  }
}

// 更新本类型玩法活跃占比图
const updateCategoryProportionChart = (data) => {
  const seriesData = Object.keys(data).map(gameName => ({
    name: gameName,
    type: 'line',
    data: data[gameName].map(item => item.category_proportion),
  }))

  categoryProportionChartOptions.value = {
    title: {
      text: '本类型玩法活跃占比',
      left: 'center'
    },
    xAxis: {
      type: 'category',
      data: data[Object.keys(data)[0]].map(item => item.hour),
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value}%'  // 格式化为百分比
      }
    },
    legend: {
      data: Object.keys(data),
      left: 'center',
      top: 30
    },
    series: seriesData
  }
}

// 工具函数：日期转 YYYY-MM-DD
function formatDate(dateObj) {
  // 如果 dateObj 不是 Date 实例，则尝试转换
  if (!(dateObj instanceof Date)) {
    dateObj = new Date(dateObj)
  }
  const y = dateObj.getFullYear()
  let m = dateObj.getMonth() + 1
  let d = dateObj.getDate()
  if (m < 10) m = '0' + m
  if (d < 10) d = '0' + d
  return `${y}-${m}-${d}`
}

// 1. 玩法1 自动补全状态
const filteredSuggestions1 = ref([])
const showSuggestions1    = ref(false)

// 2. 玩法2 自动补全状态
const filteredSuggestions2 = ref([])
const showSuggestions2    = ref(false)

/** 通用：拉取接口给定 query 的补全列表 */
async function fetchGameSuggestions(query) {
  const res = await axios.get('https://www.hudongwanfa.cn/api/search_game_dy', { params: { game_name: query } })
  return res.data.data.map(item => ({ label: item.game_name, value: item.game_name }))
}

// 玩法1 输入时
const onSearchInput1 = async () => {
  const q = gameName1.value.trim()
  if (!q) { filteredSuggestions1.value = []; return }
  try {
    filteredSuggestions1.value = await fetchGameSuggestions(q)
    showSuggestions1.value = filteredSuggestions1.value.length > 0
  } catch { filteredSuggestions1.value = [] }
}

// 玩法2 输入时
const onSearchInput2 = async () => {
  const q = gameName2.value.trim()
  if (!q) { filteredSuggestions2.value = []; return }
  try {
    filteredSuggestions2.value = await fetchGameSuggestions(q)
    showSuggestions2.value = filteredSuggestions2.value.length > 0
  } catch { filteredSuggestions2.value = [] }
}

// 玩法1 聚焦／失焦
const showDropdown1   = () => { showSuggestions1.value = true }
const hideSuggestions1 = () => setTimeout(() => showSuggestions1.value = false, 100)

// 玩法2 聚焦／失焦
const showDropdown2   = () => { showSuggestions2.value = true }
const hideSuggestions2 = () => setTimeout(() => showSuggestions2.value = false, 100)

// 玩法1 选中
const onGameSelect1 = item => {
  gameName1.value = item.value
  showSuggestions1.value = false
}

// 玩法2 选中
const onGameSelect2 = item => {
  gameName2.value = item.value
  showSuggestions2.value = false
}
</script>

<style scoped>
/* 自定义样式 */
.chart-box {
  margin: 20px 0;
  background-color: #ffe; /* 淡黄色底色 */
}

.loading-dialog .el-dialog__header {
  display: none;
}

.el-radio /deep/ .el-radio__label {
  font-size: 16px;
}

.vs-img {
  margin-top: -80px;
  width: 120px; /* 固定宽度 */
  height: auto; /* 高度等比例拉伸 */
  z-index: 0;   /* 放在最底层 */
}

.custom-autocomplete {
  position: relative;
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
}

.autocomplete-input {
  width: 100%;
  padding: 8px;
  font-size: 16px;
  box-sizing: border-box;
}

.autocomplete-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 5px rgba(0,0,0,0.15);
  z-index: 10;
  margin: 4px 0 0;
  box-sizing: border-box;
  padding: 0;
  list-style: none;
}

.autocomplete-dropdown li {
  padding: 6px 12px;
  cursor: pointer;
}

.autocomplete-dropdown li:hover {
  background-color: #f5f5f5;
}
</style>
